<ng-template #input>
	<div class="input-wrapper"
		 *transloco="let t;"
		 [class.input-required]="control.pristine && !control.disabled && isControlRequired && !control.touched">
		<ng-container *ngIf="clearable && control?.value && !defaultValue">
			<button class="btn btn-outline-default btn-reset"
					*transloco="let t;"
					(click)="clear()">
				{{ t('journal.common.clear') |uppercase }}</button>
		</ng-container>
		<button class="btn btn-outline-default btn-reset"
				*ngIf="defaultValue"
				(click)="reset()"
				type="button">
			{{ t('journal.common.reset') | uppercase }}
		</button>
		<input type="text"
			   class="form-control"
			   [ngClass]="{
			   			'input-valid': !invalidFormatDate,
			   			'input-invalid': invalidFormatDate,
			   			'control-invalid': control.invalid,
			   			'input-empty': !(control.value) && !invalidFormatDate,
			   			'popover-open': popover.isOpen(),
			   			'on-touched': control.touched
			   			}"
			   [id]="id"
			   #dateInput
			   [ngModel]="dateString | dateFormat: dateFormat: humanize"
			   [ngModelOptions]="{standalone: true}"
			   (change)="onInputChange($event)"
			   [placeholder]="placeholder ? '― ' + placeholder + ' ― ' + datePlaceholder : ' ― ' + datePlaceholder"
			   (keydown.enter)="$event.preventDefault()"
			   (click)="control.markAsTouched(); control.markAsDirty()"
			   (focus)="dateInput.classList.add('focused')"
			   (blur)="dateInput.classList.remove('focused')"
		/>

		<ng-template #calendarContent>
			<ngb-datepicker class="dp-wrapper"
							[ngModel]="dateString"
							(ngModelChange)="dateChange($event)"
							outsideDays="hidden"
							[showWeekNumbers]="true"
							[minDate]="minDate"></ngb-datepicker>
		</ng-template>

		<div class="indicators-wrapper">
			<div *ngIf="(control.touched || control.dirty) && (control.errors || invalidFormatDate)" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-xmark"></i>
				</span>
			</div>

			<div *ngIf="control.valid && !control.pristine && control.value" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-check"></i>
				</span>
			</div>

			<div *ngIf="warnings && warnings.deprecated" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fal fa-exclamation-triangle"></i>
				</span>
			</div>

			<div *ngIf="control.disabled" class="icon-indicator separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="lock" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
				</span>
			</div>

			<div class="icon-indicator action-btn separator">
				<span class="inner-wrapper">
					<button class="btn shadow-none bg-transparent"
							[container]="'body'"
							[ngbPopover]="calendarContent"
							#popover="ngbPopover"							
							(click)="dateSelect()"
							type="button"
							placement="auto">							
						<shared-icon-sprite svgId="calendar-date-2-2" height="21px" width="22px"></shared-icon-sprite>
					</button>
				</span>
			</div>
		</div>

	</div>
</ng-template>

<ng-template #vertical>
	<div class="input-group input-vertical p-0">
		<div class="input-container col-12 p-0"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.touched && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
			 [class.input-container-valid]="control.valid && control.value">
			<label [for]="id" class="w-100"
				   [class.input-valid]="control.valid && control.value"
				   [class.input-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
				   *transloco="let t; read: 'journal'">
				{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
				<ng-container *ngTemplateOutlet="input"></ng-container>
			</label>
		</div>
	</div>
</ng-template>

<ng-template #horizontal>
	<div class="input-group input-horizontal">
		<div class="input-container"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.touched && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
			 [class.input-container-valid]="control.valid && control.value">
			<label [for]="id" class="w-100"
				   [class.input-valid]="control.valid && control.value"
				   [class.input-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
				   *transloco="let t; read: 'journal'">
				{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
				<ng-container *ngTemplateOutlet="input"></ng-container>
			</label>
		</div>
	</div>
</ng-template>

<ng-template #inline>
	<button class="btn shadow-none bg-transparent form-control-inline"
			[ngbPopover]="calendarContentInline"			
			container="body"
			(click)="dateSelect()"
			type="button"
			#inlinePopover="ngbPopover">
		{{dateString | dateFormat}}
	</button>
	<ng-template #calendarContentInline>
		<div class="input-container dp-inline"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.touched && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
			 [class.input-container-valid]="control.valid && control.value">
			<div class="input-wrapper"
				 *transloco="let t;"
				 [class.input-required]="control.pristine && !control.disabled && isControlRequired && !control.touched">
				<button class="btn btn-outline-default btn-reset"
						*ngIf="defaultValue"
						(click)="reset()"
						type="button">
					{{ t('journal.common.reset') | uppercase }}
				</button>
				<input type="text"
					   class="form-control m-0"
					   [ngClass]="{
							'input-valid': !invalidFormatDate,
							'input-invalid': invalidFormatDate,
							'control-invalid': control.invalid,
							'input-empty': !(control.value) && !invalidFormatDate,
							'on-touched': control.touched
			   			}"
					   [id]="id"
					   #dateInput
					   [ngModel]="dateString | dateFormat: dateFormat: humanize"
					   [ngModelOptions]="{standalone: true}"
					   (change)="onInputChange($event)"
					   [placeholder]="placeholder ? '― ' + placeholder + ' ― ' + datePlaceholder : ' ― ' + datePlaceholder"
					   (click)="control.markAsTouched(); control.markAsDirty()"
					   (keydown.enter)="$event.preventDefault()"
					   (focus)="dateInput.classList.add('focused')"
					   (blur)="dateInput.classList.remove('focused')"
				/>
				<ngb-datepicker class="dp-wrapper"
								[ngModel]="dateString"
								(ngModelChange)="dateChange($event)"
								outsideDays="hidden"
								[showWeekNumbers]="true"
								(dateSelect)="dateSelect()"
								#datePicker
								[minDate]="minDate"
				></ngb-datepicker>

				<div class="indicators-wrapper">
					<div *ngIf="(control.touched || control.dirty) && (control.errors || invalidFormatDate)" class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fa-solid fa-xmark"></i>
						</span>
					</div>

					<div *ngIf="control.valid && !control.pristine && control.value" class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fa-solid fa-check"></i>
						</span>
					</div>

					<div *ngIf="warnings && warnings.deprecated" class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fal fa-exclamation-triangle"></i>
						</span>
					</div>

					<div *ngIf="control.disabled" class="icon-indicator separator">
						<span class="inner-wrapper">
							<shared-icon-sprite svgId="lock" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
						</span>
					</div>
				</div>
			</div>
		</div>
	</ng-template>

</ng-template>

<ng-template #dateAndTime>
	<button class="btn shadow-none bg-transparent form-control-inline custom-template-trigger"  [popoverClass]="'custom-popover bs-popover-bottom'" [ngbPopover]="dateAndTimeContent"
		container="body" triggers="manual" #dateAndTimePopover="ngbPopover" type="button" (click)="dateSelect()" >	
	</button>

	<ng-template #dateAndTimeContent>
		
		<div class="input-container dp-inline  extended-calendar-content custom-popover"[class.input-disabled]="control.disabled"
			[class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.touched && !control.value)"
			[class.input-container-invalid]="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
			[class.input-container-valid]="control.valid && control.value">
			<div class="input-wrapper" *transloco="let t;"
				[class.input-required]="control.pristine && !control.disabled && isControlRequired && !control.touched">
	
				<button class="btn btn-outline-default btn-reset" *ngIf="defaultValue" (click)="reset()" type="button">
					{{ t('journal.common.reset') | uppercase }}
				</button>
			
				<input type="text" class="form-control m-0" [ngClass]="{
				    'input-valid': !invalidFormatDate,
				    'input-invalid': invalidFormatDate,
				    'control-invalid': control.invalid,
				    'input-empty': !(control.value) && !invalidFormatDate,
				    'on-touched': control.touched
				  }" [id]="id" #dateInput [value]="dateString ? (dateString | date:'dd MMM yyyy - HH:mm') : ''" readonly
					(click)="control.markAsTouched(); control.markAsDirty()" (keydown.enter)="$event.preventDefault()"
					(focus)="dateInput.classList.add('focused')" (blur)="dateInput.classList.remove('focused')" />
		 
				
				<ngb-datepicker class="dp-wrapper" [ngModel]="dateString" (ngModelChange)="dateChange($event)"
					outsideDays="hidden" [showWeekNumbers]="true" [maxDate]="maxDate" [minDate]="minDate" #datePicker>
				</ngb-datepicker>

				<label for="entryChangetime" class="label c-pl-1">{{ t('journal.edit.selectTime') }} :</label>
				<div id="entryChangetime" class="px-2 timepicker-wrapper">
					<form-timepicker [control]="formGroupControls.time" [template]="ControlTemplate.inline">
						</form-timepicker>
				</div>
				<div class="indicators-wrapper">
					<div *ngIf="(control.touched || control.dirty) && (control.errors || invalidFormatDate)"
						class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fa-solid fa-xmark"></i>
						</span>
					</div>

					<div *ngIf="control.valid && !control.pristine && control.value" class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fa-solid fa-check"></i>
						</span>
					</div>

					<div *ngIf="warnings?.deprecated" class="icon-indicator separator">
						<span class="inner-wrapper">
							<i class="fal fa-exclamation-triangle"></i>
						</span>
					</div>

					<div *ngIf="control.disabled" class="icon-indicator separator">
						<span class="inner-wrapper">
							<shared-icon-sprite svgId="lock" height="22px" width="18px"
								class="mb-2"></shared-icon-sprite>
						</span>
					</div>
				</div>
			</div>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</div>
	</ng-template>
</ng-template>


<ng-template #errors>
		<ng-container *ngIf="control.touched">
		<div class="control-errors-wrapper">
			<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 class="control-errors col-12" *ngFor="let error of control.errors | keyvalue">
				<span class="error" *transloco="let t">{{ t('journal.generic.' + error.key) }}</span>
			</div>
			<div *ngIf="invalidFormatDate"
				 [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 class="control-errors col-12">
				<span class="error" *transloco="let t">{{ t('journal.generic.formatInvalid') }}</span>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-container>
	<ng-container [ngSwitch]="template">
		<div *ngIf="template !== 'inline' && template !== 'dateAndTime'" class="form-control-container">
			<ng-container *ngSwitchCase="ControlTemplate.horizontal">
				<ng-container *ngTemplateOutlet="horizontal"></ng-container>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="ControlTemplate.vertical">
				<ng-container *ngTemplateOutlet="vertical"></ng-container>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</div>
		<div class="form-control-inline-wrapper"
				[ngClass]="{'align-center': inlineAlign === 'center',
							'align-left': inlineAlign === 'left',
					'		 align-right': inlineAlign === 'right'}">
			<ng-container *ngSwitchCase="ControlTemplate.inline">
				<ng-container *ngTemplateOutlet="inline"></ng-container>
			</ng-container>
		</div>
		<ng-container *ngSwitchCase="ControlTemplate.dateAndTime">
			<div class="form-control-container c-pl-1">
				<div class="form-control-inline-wrapper" [ngClass]="{'align-center': inlineAlign === 'center',
											 'align-left': inlineAlign === 'left',
											 'align-right': inlineAlign === 'right'}">
					<ng-container *ngTemplateOutlet="dateAndTime"></ng-container>
				</div>
			
				</div>
	</ng-container>
</ng-container>
